"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEndOfMonthDates = exports.getDatesRangeStartOfDay = exports.daysInRange = exports.daysInYear = void 0;
var date_fns_1 = require("date-fns");
var daysInYear = function (year) {
    return (year % 4 === 0 && year % 100 > 0) || year % 400 === 0 ? 366 : 365;
};
exports.daysInYear = daysInYear;
var daysInRange = function (start, end) { return (0, date_fns_1.differenceInDays)((0, date_fns_1.endOfDay)(end), (0, date_fns_1.startOfDay)(start)) + 1; };
exports.daysInRange = daysInRange;
var getDatesRangeStartOfDay = function (dateFrom, dateTo) {
    var result = [];
    var current = (0, date_fns_1.startOfDay)(dateFrom);
    while (!(0, date_fns_1.isAfter)(current, dateTo)) {
        result.push(current);
        current = (0, date_fns_1.startOfDay)((0, date_fns_1.addDays)(current, 1));
    }
    return result;
};
exports.getDatesRangeStartOfDay = getDatesRangeStartOfDay;
var getEndOfMonthDates = function (dateFrom, dateTo) {
    var result = [];
    var current = (0, date_fns_1.startOfDay)(dateFrom);
    var currentEndOfMonth = (0, date_fns_1.startOfDay)((0, date_fns_1.endOfMonth)(current));
    while (!(0, date_fns_1.isAfter)(currentEndOfMonth, dateTo)) {
        result.push(currentEndOfMonth);
        current = (0, date_fns_1.addMonths)(current, 1);
        currentEndOfMonth = (0, date_fns_1.startOfDay)((0, date_fns_1.endOfMonth)(current));
    }
    if (result.length && !(0, date_fns_1.isEqual)(result[result.length - 1], (0, date_fns_1.startOfDay)(dateTo))) {
        result.push((0, date_fns_1.startOfDay)(dateTo));
    }
    return result;
};
exports.getEndOfMonthDates = getEndOfMonthDates;
//# sourceMappingURL=date-utils.js.map